module.exports = __webpack_public_path__ + "static/media/_sint-maarten.8d3d0e5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_sint-maarten.svg
// module id = 2351
// module chunks = 7